module.exports = __webpack_public_path__ + "img/faq.4479c2f9.svg";